import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';

import { TenantIpRangeComponent } from './tenant-employee/tenant-ip-range/tenant-ip-range.component';

/**
 * 租戶公網 IP 範圍管理獨立頁面包裝組件
 */
@Component({
  selector: 'app-tenant-ip-range-page',
  standalone: true,
  imports: [TenantIpRangeComponent, TestIdDirective],
  template: ` <tenant-ip-range [tenantId]="tenantId" [testId]="'tenant-ip-range-page'" /> `
})
export class TenantIpRangePageComponent {
  private readonly route = inject(ActivatedRoute);

  readonly tenantId = this.route.snapshot.paramMap.get('tenantId') ?? '';
}
